import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'
export class ShotNode extends BaseNode {
    next = NodeType.Transition
    enableSuggestions = false

    static getType(): string {
        return 'shot'
    }

    static clone(node: ShotNode): ShotNode {
        return new ShotNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(): HTMLElement {
        const dom = document.createElement('div')
        dom.className = 'shot node-style-common avoid-page-break'
        return dom
    }

    static importJSON(jsonNode: SerializedBaseNode): ShotNode {
        return new ShotNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }
}
